import React from 'react';
import { Grid, Paper, Typography, Tooltip } from '@mui/material';
import { INK } from '../../utils/commercialColors';

// Stat tiles, not a chart - per the dataviz method, four period figures
// side by side don't need a plot. Delta-style figures (new/churned) use
// the fixed success/critical ink tokens; mrr_total (a snapshot, not a
// change) stays neutral.
function Tile({ label, value, color, hint }) {
  return (
    <Grid size={{ xs: 6, md: 3 }}>
      <Tooltip title={hint || ''} disableHoverListener={!hint}>
        <Paper elevation={1} sx={{ p: 2, height: '100%' }}>
          <Typography variant="caption" sx={{ color: INK.muted, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {label}
          </Typography>
          <Typography variant="h6" sx={{ color, fontVariantNumeric: 'tabular-nums', mt: 0.5 }}>
            {value}
          </Typography>
        </Paper>
      </Tooltip>
    </Grid>
  );
}

const fmt = (n) => `${Number(n).toLocaleString('fr-FR')} €`;

export default function MRRChart({ mrr }) {
  if (!mrr) return null;
  const { new_mrr, churned_mrr, net_new_mrr, mrr_total, scope_note } = mrr;

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        MRR
      </Typography>
      <Grid container spacing={2}>
        <Tile label="New MRR" value={`+${fmt(new_mrr)}`} color={INK.success} hint={scope_note} />
        <Tile label="Churned MRR" value={`-${fmt(churned_mrr)}`} color="#d03b3b" hint={scope_note} />
        <Tile
          label="Net New MRR"
          value={`${net_new_mrr >= 0 ? '+' : ''}${fmt(net_new_mrr)}`}
          color={net_new_mrr >= 0 ? INK.success : '#d03b3b'}
          hint={scope_note}
        />
        <Tile label="MRR total" value={fmt(mrr_total)} color={INK.primary} />
      </Grid>
      <Typography variant="caption" sx={{ color: INK.muted, display: 'block', mt: 1.5 }}>
        {scope_note}
      </Typography>
    </Paper>
  );
}
